<app-header-hs1 titulo="Projeto"  (eventSave)="save()" (eventCancel)="voltar()" [deletavel]="deletavel" [editavel]="true"
                (eventDelete)="delete()"/>

<ion-content [fullscreen]="true">
  <ion-list [inset]="true">
    <form #form="ngForm">

        <ion-item>
          <ion-input type="text" name="nome" label-placement="floating" required label="Nome" [(ngModel)]="entidade.nome"/>
        </ion-item>

        <ion-item>
          <ion-input name="inicio" type="date" label-placement="floating" required label="Inicio" [(ngModel)]="entidade.inicio"/>
        </ion-item>

        <ion-item>
          <ion-input name="fim" type="date" label-placement="floating"  label="Fim" [(ngModel)]="entidade.fim"/>
        </ion-item>
        <app-selecao-local [(local)]="entidade.local"/>

      <app-metodo [(entidades)]="entidade.metodologias"/>
      <app-campanha [(entidades)]="entidade.campanhas"/>
      <app-arquivo [(entidades)]="entidade.arquivos"/>

    </form>
  </ion-list>
</ion-content>

<app-rodape [exibirBotoes]="false"/>
